
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M53.5 52.5V10.86a9.21 9.21 0 00-9-9.36h-29a9.21 9.21 0 00-9 9.36V52.5zM42.25 12.58h11.02M6.73 12.58h11.1M6.73 35.9h46.54","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('circle',{attrs:{"cx":"15.75","cy":"44.5","r":"3.5","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('circle',{attrs:{"cx":"44.25","cy":"44.5","r":"3.5","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M30 15.5v20M16.5 52.5v6h-7v-6M50.5 52.5v6h-7v-6M6.5 29.5h-5v-11h5M53.5 18.5h5v11h-5M18 9.25h24v7H18z"}})])
          )
        }
      }
    